import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import moment from 'moment';

function SongCard(props) {
    const [lastPlayType, setLastPlayType] = useState(0)
    const songId = props.data[0]
    return (
        <div className="flex flex-wrap items-center mt-4">
        <div className="w-2/3 md:w-2/3 text-left text-pink-400">
        <Link to={"/s/" + songId}>
            <p className="text-xl md:text-2xl font-bold font-sans">#{props.rank} - {props.data[1]}</p>
            <p className="text-lg md:text-xl font-sans">{props.data[2]}</p>
        </Link>
        </div>
        <div className="w-1/3 md:w-1/3 text-right text-pink-400">
        <p className="text-xl md:text-2xl font-bold font-sans">{props.data[4]} plays</p>
        {/* <p className="text-lg md:text-xl font-sans">{new Date(props.data[3] * 1000).toLocaleString()}</p> */}
        <p className="text-lg md:text-xl font-sans"
        onClick={() => {
            if (lastPlayType == 0) {
                setLastPlayType(1)
            } else {
                setLastPlayType(0)
            }
        }}
        >{lastPlayType == 0 ? ("Played " + moment.unix(props.data[3]).fromNow()) : new Date(props.data[3] * 1000).toLocaleString()}</p>
        </div>
        </div>
    )
}

export default SongCard
